import { useFirebase } from 'components/Firebase/index.js';
import useOrgId from './useOrgId.js';
import { useQuery } from 'react-query';

const useVodSettings = () => {
  const firebase = useFirebase();
  const orgId = useOrgId();

  return useQuery({
    enabled: !!orgId,
    queryKey: ['vod-settings', orgId],
    queryFn: async () => {
      const agent = await firebase.getAgent();
      const { body } = await agent.get(`/o/${orgId}/settings/vod`);
      return body;
    },
  });
};

export default useVodSettings;
